import { millisecondsInDay } from 'date-fns/constants'
import { millisecondsToHours } from 'date-fns/millisecondsToHours'
import { millisecondsToMinutes } from 'date-fns/millisecondsToMinutes'
import { millisecondsToSeconds } from 'date-fns/millisecondsToSeconds'

// This is an elapsed duration, independent of calendar days and browser DST transitions.
export function formatCutoffCountdown(remaining: number | null | undefined) {
  const milliseconds = Math.max(remaining ?? 0, 0)
  const totalDays = Math.floor(milliseconds / millisecondsInDay)
  const hourPart = millisecondsToHours(milliseconds) % 24
  const hours = String(hourPart).padStart(2, '0')
  const minutes = String(millisecondsToMinutes(milliseconds) % 60).padStart(2, '0')
  const seconds = String(millisecondsToSeconds(milliseconds) % 60).padStart(2, '0')
  return {
    label:
      totalDays > 0
        ? `${totalDays}d ${hours}h ${minutes}m ${seconds}s`
        : `${hours}:${minutes}:${seconds}`,
    isUrgent: totalDays === 0 && hourPart < 12,
  }
}
